export default "__VITE_ASSET__DG7K$GN3__"